import {
  createValidator,
  stringLength,
  stringTrim,
  combineValidators,
  isStringContainsAllowedLinksQuantity,
} from 'app/validators/base'
import i18next from 'i18next'
import { getInnerTextFromHtmlString } from 'helpers/common'

export const validateDescriptionWhenVideoIsSelected = (value: any, values: any) => {
  // eslint-disable-next-line no-useless-escape
  const anchorTagsRegEx = /<a[\s]+([^>]+)>((?:.(?!\<\/a\>))*.)<\/a>/g
  const isDescriptionContainLinks = value && value.match(anchorTagsRegEx)?.length >= 1
  if (value && values && values.get && values.get('videoThumbnail') && isDescriptionContainLinks) {
    return {
      isValid: false,
      message: i18next.t(`admin:description can't contain a link when video is selected`),
    }
  }
}

const validate = combineValidators([
  value => {
    if (value && value.length > 2000) {
      return {
        isValid: false,
        message: i18next.t('admin:total characters number must be less than', { max: 2000 }),
      }
    }
  },
  validateDescriptionWhenVideoIsSelected,
  stringLength({ min: 1, max: 800 }, value => stringTrim(getInnerTextFromHtmlString(value))),
  isStringContainsAllowedLinksQuantity({
    message: 'admin:description can contain maximum 5 links',
    allowedLinksQuantity: 5,
  }),
])

export default createValidator(validate, 'description')
